import { CuteIcon } from '@/shared/components/CuteIcon'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useShortcutSync } from '@/app/AppProviders'

const shortcutURL = `shortcuts://run-shortcut?name=${encodeURIComponent('CareBaby 体重同步')}`

export function TodaySyncPanel() {
  const sync = useShortcutSync()
  const [status, setStatus] = useState(sync?.status ?? '')
  const [busy, setBusy] = useState(false)
  useEffect(() => {
    if (!sync) return
    return sync.subscribe(() => setStatus(sync.status))
  }, [sync])
  if (!sync) return null

  const refresh = async () => {
    setBusy(true)
    try { await sync.sync() }
    catch { setStatus('暂时无法刷新，请稍后重试') }
    finally { setBusy(false) }
  }

  return <section className="today-sync" aria-labelledby="today-sync-title">
    <div className="today-sync__heading">
      <h2 id="today-sync-title"><span aria-hidden="true"><CuteIcon name="sync" /></span> 健康同步</h2>
      <span className="today-sync__badge">{sync.enabled ? '已连接' : '未连接'}</span>
    </div>
    <p className="today-sync__status" role="status">{status}</p>
    {sync.enabled ? <>
      <div className="today-sync__actions">
        <a className="today-sync__primary" href={shortcutURL}><span aria-hidden="true"><CuteIcon name="heart" /></span> 更新健康数据</a>
        <button aria-label="刷新云端数据" type="button" disabled={busy || status === '正在同步…'} onClick={() => void refresh()}>
          <span aria-hidden="true">↻</span> {busy ? '刷新中…' : '刷新'}
        </button>
      </div>
      <details className="sync-help"><summary>同步小贴士</summary><p className="today-sync__help">运行「CareBaby 体重同步」，上传体重、体脂、睡眠和活动卡路里；返回这里自动刷新。手动记录仅保存在本机。</p></details>
    </> : <>
      <p className="today-sync__help">首次连接后，打开页面就会读取已上传的数据。</p>
      <Link className="today-sync__primary" to="/settings">配置同步</Link>
    </>}
  </section>
}
